module.exports = __webpack_public_path__ + "static/media/Group 1512@3x.d8158075.png";